import { Suspense } from 'react'
import type { DashboardItem } from 'src/types/dashboard'
import ChartSkeleton from '@components/skeletons/ChartSkeleton/ChartSkeleton'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import Loader from '@components/Loader/Loader'
import Popover from '@components/Popover/Popover'
import ChartArea from './ChartArea/ChartArea'
import ChartHeaderRight from './ChartHeaderRight'
import ErrorChart from './ErrorChart/ErrorChart'
import ErrorMessageChart from './ErrorChart/ErrorMessageChart'
import { S3_IMAGE_BUCKET } from 'src/constants/global'

import './WidgetView.css'

interface WidgetViewProps {
  item: DashboardItem
}

export default function WidgetView({ item }: WidgetViewProps) {
  if (item.type === 'spacer') {
    return <article className="widget-view widget-view-spacer" />
  }
  if (item.type === 'label') {
    return (
      <article className="widget-view widget-view-label">
        <h3 title={item.title}>{item.title}</h3>
        <p>{item.text}</p>
      </article>
    )
  }

  if (item.type === 'image') {
    return (
      <article className="widget-view widget-view-image">
        <div className="wrapper-image">
          <img
            src={`${S3_IMAGE_BUCKET}/images/${item.image}.png`}
            alt={item.title}
          />
          {item.title && <h3 title={item.title}>{item.title}</h3>}
        </div>
      </article>
    )
  }

  return (
    <article className="widget-view widget-view-chart">
      <header className="widget-view-header">
        <section className="side side-left">
          <h3 title={item.title} className="ellipsis">
            {item.title}
          </h3>
          {item.description && (
            <Popover
              popoverClassName="popover-info"
              buttonClassName="info-btn"
              triggerContent={<span className="icon icon-info" />}
            >
              {item.description}
            </Popover>
          )}
        </section>
        <section className="side side-right">
          <ErrorBoundary errorComponent={ErrorMessageChart}>
            <Suspense fallback={<Loader mini />}>
              <ChartHeaderRight queryId={item.query} />
            </Suspense>
          </ErrorBoundary>
        </section>
      </header>
      <ErrorBoundary errorComponent={ErrorChart}>
        <Suspense fallback={<ChartSkeleton />}>
          <ChartArea
            queryId={item.query}
            chartType={item.type}
            xAxis={item.xAxis}
            yAxis={item.yAxis}
            geoColumn={item.geoColumn}
            overrides={item.overrides}
          />
        </Suspense>
      </ErrorBoundary>
    </article>
  )
}
